<template>
  <div class="folder-breadcrumb">
    <div class="folder-breadcrumb-wrapper">
      <div class="folder-breadcrumb-icon" />
      <div
        v-for="folder in folders"
        :key="folder.custFolderCode"
        class="folder-breadcrumb-item"
      >
        <div @click="openFolder(folder)">{{ folder.custFolderName }}</div>
        <div class="folder-breadcrumb-right" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { parentCode: { type: String, default: '' } },
  data() {
    return { folders: [] }
  },
  watch: {
    parentCode() {
      this.getData()
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.parentCode) return
      const res = await this.$api
        .masterCustomerFolderLevelApi({ parentCode: this.parentCode })
        .catch(() => null)
      this.folders = res?.body?.data
    },
    openFolder({ custFolderCode }) {
      if (this.parentCode == custFolderCode) return

      this.$emit('openFolder', { custFolderCode })
    },
  },
}
</script>
<style lang="scss" scoped>
.folder-breadcrumb {
  display: flex;
  color: #007bff;
  font-weight: 500;
  font-size: 14px;
}
.folder-breadcrumb-wrapper {
  display: flex;
  align-items: center;
  padding: 6px;
  background-color: #e9f3ff;
  border-radius: 5px;
  .folder-breadcrumb-icon {
    width: 20px;
    height: 20px;
    min-width: 20px;
    background-image: url('../../../icons/folder-breadcrumb.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .folder-breadcrumb-item {
    padding: 0 6px;
    display: flex;
    align-items: center;

    > div:not(.folder-breadcrumb-right) {
      cursor: pointer;
    }

    .folder-breadcrumb-right {
      margin-left: 8px;
      width: 16px;
      height: 16px;
      min-width: 16px;
      background-image: url('../../../icons/folder-breadcrumb-right.png');
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }
  .folder-breadcrumb-item:last-child {
    > div:not(.folder-breadcrumb-right) {
      cursor: auto;
    }
    .folder-breadcrumb-right {
      display: none;
    }
  }
}
</style>
